import React from "react";
import CustomSelect from "../common/Select";

const opcionesTipoDocumento = [
  { value: "CC", label: "CC - CEDULA DE CIUDADANIA" },
  { value: "CE", label: "CE - CEDULA DE EXTRANJERIA" },
  { value: "CD", label: "CD - CARNET DIPLOMATICO" },
  { value: "CN", label: "CN - CERTIFICADO DE NACIDO VIVO" },
  { value: "DE", label: "DE - DOCUMENTOS EXTRANJERO" },
  { value: "MS", label: "MS - MENOR SIN IDENTIFICAR" },
  { value: "NIP", label: "NIP - NUMERO DE IDENTIFICACION PERSONAL" },
  { value: "NIT", label: "NIT - NUMERO DE IDENTIFICACION TRIBUTARIA" },
  { value: "PA", label: "PA - PASAPORTE" },
  { value: "PT", label: "PT - PERMISO TEMPORAL DE PERMANENCIA" },
  { value: "PE", label: "PE - PERMISO ESPECIAL DE PERMANENCIA" },
  { value: "RC", label: "RC - REGISTRO CIVIL" },
  { value: "TI", label: "TI - TARJETA DE IDENTIDAD" },
  { value: "SC", label: "SC - SALVOCONDUCTO DE PERMANENCIA" },
  { value: "SI", label: "SI - SIN IDENTIFICACION" },
  { value: "AS", label: "AS - ADULTO SIN IDENTIFICAR" }
];

function SelectorTipoDocumento({ value, onChange, error, required = false }) {
  return (
    <CustomSelect
      options={opcionesTipoDocumento}
      value={value}
      onChange={onChange}
      placeholder=""
      label="Tipo Documento"
      error={error}
      required={required}
    />
  );
}

export default SelectorTipoDocumento;